import React from 'react';
import { Page } from '../Page';
import { ShieldCheck, Award } from 'lucide-react';
export function PageSupplementQuality() {
  return <Page pageNumber={13} variant="light" data-id="element-1440">
      <div className="flex flex-col h-full" data-id="element-1441">
        {/* Hero Image */}
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1442">
          <img src="https://images.unsplash.com/photo-1584017911766-d451b3d0e843?w=1000&q=80" alt="Supplements and vitamins" className="w-full h-full object-cover" data-id="element-1443" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1444" />
        </div>

        <div className="mb-6" data-id="element-1445">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1446">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1447">
            Supplement <span className="text-tealslate" data-id="element-1448">Quality</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1449" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1450">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1451">
            The supplement industry is largely unregulated. What's on the label
            isn't always what's in the bottle. When you're eating less and
            relying on supplements to fill critical nutritional gaps, you cannot
            afford to take products that don't absorb or contain fillers.
          </p>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1452">
            Your body is already under stress from rapid weight loss and reduced
            food intake. Adding unknown contaminants, heavy metals, or
            inaccurate dosing on top of that is an unnecessary risk. You need to
            know exactly what you are putting into your body.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-1453">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1454">
            <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mb-3" data-id="element-1455">
              <ShieldCheck className="w-5 h-5 text-tealslate" data-id="element-1456" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-2" data-id="element-1457">
              NSF Certified for Sport
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1458">
              Tests for label accuracy, screens for contaminants, and tests for
              banned substances. The gold standard used by professional and
              Olympic athletes.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1459">
            <div className="w-10 h-10 rounded-full bg-navyslate/40 border border-navyslate/60 flex items-center justify-center mb-3" data-id="element-1460">
              <Award className="w-5 h-5 text-tealslate" data-id="element-1461" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-2" data-id="element-1462">
              Informed Choice
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1463">
              An independent batch testing program for banned substances and
              contaminants. Trusted globally by athletes and healthcare
              providers.
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-1464">
          <div className="border-l-4 border-tealslate pl-6 py-2" data-id="element-1465">
            <p className="text-base font-serif italic text-[#1F1F1F] leading-relaxed mb-2" data-id="element-1466">
              "If a supplement company will not pay for third-party testing, ask
              yourself why."
            </p>
            <p className="text-xs text-[#7A7A70]" data-id="element-1467">
              We recommend <strong className="text-[#1F1F1F]" data-id="element-1468">Thorne</strong>,
              NSF Certified for Sport, pharmaceutical-grade standards.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}